var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{staticClass:"container mx-auto py-4"},[_c('router-view',{staticClass:"mt-2"})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }